import { MoneyPageLinks } from "@/components/money-page/MoneyPageLinks";
import { getHubConnections, getLocationConnections, getCta, getLocationNode, getHub } from "@/data/knowledgeGraph";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface KnowledgeConnectionsProps {
  /** Ruta de una página local (LOCATION_NODES) */
  path?: string;
  /** O bien el id de un hub temático (KNOWLEDGE_HUBS) */
  hub?: string;
  language?: 'es' | 'en';
}

/**
 * FASE 5 — bloque de relaciones editoriales del knowledge graph.
 * Conecta la página con su hub, sus servicios, su evidencia y su CTA por intención.
 * No renderiza nada si no hay relaciones reales que mostrar.
 */
export const KnowledgeConnections = ({ path, hub, language = 'es' }: KnowledgeConnectionsProps) => {
  const links = path
    ? getLocationConnections(path, language)
    : hub
      ? getHubConnections(hub, language)
      : [];

  if (!links.length) return null;

  const hubId = hub ?? getLocationNode(path ?? '')?.hub;
  const intent = (hubId && getHub(hubId)?.intent) || 'seo';
  const cta = getCta(intent, language);

  return (
    <>
      <MoneyPageLinks
        title={language === 'es' ? 'Cómo se conecta este trabajo' : 'How this work connects'}
        subtitle={
          language === 'es'
            ? 'El servicio, la metodología, la evidencia disponible y el contenido relacionado.'
            : 'The service, the methodology, the available evidence and related reading.'
        }
        links={links}
        language={language}
      />
      <section className="border-b border-border bg-background py-12">
        <div className="container-custom">
          <Link
            to={cta.to}
            className="inline-flex items-center gap-2 text-base font-semibold text-brand hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
          >
            {cta.label}
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>
      </section>
    </>
  );
};
